import { expressionDefinitionApiV2, llpaCapCriteriaApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LLPA_CAP_ACTION_TYPE = createNamedActions('llpaCap', {
  GET_LLPA_CAP_CRITERIA: 'GET_LLPA_CAP_CRITERIA',
  ADD_LLPA_CAP_CRITERIA: 'ADD_LLPA_CAP_CRITERIA',
  EDIT_LLPA_CAP_CRITERIA: 'EDIT_LLPA_CAP_CRITERIA',
  DELETE_LLPA_CAP_CRITERIA: 'DELETE_LLPA_CAP_CRITERIA',
  GET_SCHEMA: 'GET_SCHEMA',
});

const criteria = new schema.Entity('data', {}, { idAttribute: 'criteriaId' });

export const getLlpaCapCriteriaAction = catchAsyncActionError((params = {}) => async dispatch => {
  const { data } = await llpaCapCriteriaApi.getCriteria(params);

  return dispatch({
    type: LLPA_CAP_ACTION_TYPE.GET_LLPA_CAP_CRITERIA,
    payload: normalize(data, [criteria]).entities.data,
  });
});

export const addLlpaCapCriteriaAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await llpaCapCriteriaApi.createCriteria(params);

  return dispatch({
    type: LLPA_CAP_ACTION_TYPE.ADD_LLPA_CAP_CRITERIA,
    payload: data,
  });
});

export const editLlpaCapCriteriaAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await llpaCapCriteriaApi.editCriteria(params);

  return dispatch({
    type: LLPA_CAP_ACTION_TYPE.EDIT_LLPA_CAP_CRITERIA,
    payload: data,
  });
});

export const deleteLlpaCapCriteriaAction = catchAsyncActionError(params => async dispatch => {
  await llpaCapCriteriaApi.deleteCriteria(params);

  return dispatch({
    type: LLPA_CAP_ACTION_TYPE.DELETE_LLPA_CAP_CRITERIA,
    meta: { criteriaId: params.criteriaId },
  });
});

export const getLlpaCapSchemaAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await expressionDefinitionApiV2.getLlpaCapSchemaExpressionDefinition();

  return dispatch({
    type: LLPA_CAP_ACTION_TYPE.GET_SCHEMA,
    payload: data,
  });
});
